import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import _ from 'lodash';

import { TdAjax } from 'app/lib/tdAjax';

import {
  FETCH_MULTICONTRACT_RELATIONS,
  fetchMultiContractRelationSuccess,
  fetchMultiContractRelationFailure,
  CREATE_MULTICONTRACT_RELATION,
  createMultiContractRelationSuccess,
  createMultiContractRelationFailure,
  SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS,
  searchBenefitSponsorContractOrgRelationsSuccess,
  searchBenefitSponsorContractOrgRelationsFailure
} from './actions';

const fetchMultiContractRelationEpic = action$ =>
  action$.pipe(
    ofType(FETCH_MULTICONTRACT_RELATIONS),
    mergeMap(action =>
      TdAjax.get('/multi_contract_org_relations', action.payload).pipe(
        map(response => fetchMultiContractRelationSuccess(response)),
        catchError(error => of(fetchMultiContractRelationFailure([error]))))
  ));

const createMultiContractOrgRelationEpic = action$ =>
  action$.pipe(
    ofType(CREATE_MULTICONTRACT_RELATION),
    mergeMap(action =>
      TdAjax.post('/multi_contract_org_relations', action.payload).pipe(
        map(response => {
          const errors = response.response.errors.base;
          if (errors && !_.isEmpty(errors)) {
            return createMultiContractRelationFailure(errors);
          }
          return createMultiContractRelationSuccess(response);
        }),
        catchError(error => of(createMultiContractRelationFailure([error]))))));

const searchBenefitSponsorContractRelationsEpic = action$ =>
  action$.pipe(
    ofType(SEARCH_BENEFIT_SPONSOR_CONTRACT_ORG_RELATIONS),
    mergeMap(action =>
      TdAjax.get('/benefit_sponsor_contract_org_relations/search', action.payload).pipe(
        map(response =>
          searchBenefitSponsorContractOrgRelationsSuccess(response, action.payload.orgSide
        )),
        catchError(error => of(searchBenefitSponsorContractOrgRelationsFailure([error]))))
  ));

export {
  createMultiContractOrgRelationEpic,
  fetchMultiContractRelationEpic,
  searchBenefitSponsorContractRelationsEpic
};

export default combineEpics(
  createMultiContractOrgRelationEpic,
  fetchMultiContractRelationEpic,
  searchBenefitSponsorContractRelationsEpic
);
